import { render, staticRenderFns } from "./ArTermsOfUse.vue?vue&type=template&id=6e5920d9&scoped=true"
import script from "./ArTermsOfUse.vue?vue&type=script&lang=js"
export * from "./ArTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6e5920d9",
  null
  ,true
)

export default component.exports